module.exports = __webpack_public_path__ + "img/certificate1-06.64e4a3b9.png";